import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../firebase";
import { getDoc, doc } from "firebase/firestore";
import { killswitchDb } from "../firebaseKillswitch";

import { FaUser, FaLock, FaEye, FaEyeSlash, FaSignInAlt } from "react-icons/fa";

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async () => {
  try {
    // --- KILLSWITCH CHECK ---
    const killswitchDocRef = doc(killswitchDb, "appConfig", "killswitch");
    const killswitchSnap = await getDoc(killswitchDocRef);

    if (killswitchSnap.exists() && killswitchSnap.data().enabled === false) {
  alert("The application is currently disabled.");
  return; // Stop login
}


    // --- LOGIN LOGIC (existing) ---
    const agentDocRef = doc(db, "agents", username);
    const agentSnap = await getDoc(agentDocRef);

    if (agentSnap.exists()) {
      const agentData = agentSnap.data();
      if (agentData.password === password) {
        localStorage.setItem("currentUser", username);
        localStorage.setItem("userRole", agentData.role || "agent");
        navigate("/dashboard");
        window.location.reload();
        return;
      } else {
        alert("Invalid password.");
        return;
      }
    }

    const userDocRef = doc(db, "users", username);
    const userSnap = await getDoc(userDocRef);

    if (!userSnap.exists()) {
      alert("User not found.");
      return;
    }

    const userData = userSnap.data();

    if (userData.password !== password) {
      alert("Invalid password.");
      return;
    }

    localStorage.setItem("currentUser", username);
    localStorage.setItem("userRole", userData.role);

    navigate("/dashboard");
    window.location.reload();
  } catch (err) {
    console.error(err);
    setError("An error occurred during login.");
  }
};


  return (
    <div className="login-container">
      <div className="login-box">
       <img
  src="/approved-logos.png"
  alt="Approved by"
  style={{
    display: "block",
    margin: "0 auto 1.5rem auto",
    width: "50%"
  }}
/>


        <h2 className="login-title">
          <FaUser className="login-icon" /> Client Login
        </h2>
        <p className="login-subtext">
          Enter your password to access your account.
        </p>

        <div className="login-field">
          <label className="login-label">Username</label>
          <div className="login-input-wrapper">
            <FaUser className="input-icon" />
            <input
              type="text"
              placeholder="Enter your username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="login-input"
            />
          </div>
        </div>

        <div className="login-field">
          <label className="login-label">Password</label>
          <div className="login-input-wrapper">
            <FaLock className="input-icon" />
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="login-input"
            />
            <button
              type="button"
              className="eye-button"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>
        </div>

        {error && <div className="login-error">{error}</div>}

        <button className="login-button" onClick={handleLogin}>
          <FaSignInAlt className="login-btn-icon" />
          Login
        </button>
      </div>

      {/* CSS */}
      <style>{`
        .login-container {
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: #f5f5f5;
          min-height: 100vh;
        }

        .login-box {
          background: white;
          padding: 40px 32px;
          border-radius: 12px;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
          max-width: 400px;
          width: 100%;
          text-align: center;
        }

        .login-logos {
          max-width: 80%;
          margin-bottom: 24px;
        }

        .login-title {
          font-size: 22px;
          font-weight: bold;
          margin-bottom: 6px;
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 8px;
        }

        .login-subtext {
          font-size: 14px;
          color: #666;
          margin-bottom: 24px;
        }

        .login-field {
          width: 100%;
          margin-bottom: 20px;
          text-align: left;
        }

        .login-label {
          display: block;
          margin-bottom: 6px;
          font-weight: 500;
        }

        .login-input-wrapper {
          position: relative;
        }

        *, *::before, *::after {
  box-sizing: border-box;
}

.login-input {
  width: 100%;
  padding: 12px 40px 12px 36px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
  background-color: #f5f5f5;
  color: #333;
  box-sizing: border-box; /* ✅ THIS FIXES THE OVERFLOW */
}


        .login-input:focus {
          outline: none;
          border-color: #1e1eaa;
        }

        .input-icon {
          position: absolute;
          top: 50%;
          left: 10px;
          transform: translateY(-50%);
          color: #888;
          font-size: 16px;
        }

        .eye-button {
          position: absolute;
          top: 50%;
          right: 10px;
          transform: translateY(-50%);
          background: none;
          border: none;
          cursor: pointer;
          color: #888;
          padding: 0;
          font-size: 16px;
        }

        .login-error {
          color: red;
          font-size: 14px;
          margin-bottom: 16px;
        }

        .login-button {
          width: 100%;
          padding: 12px;
          background-color: #1e1eaa;
          color: white;
          border: none;
          border-radius: 6px;
          font-size: 16px;
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 10px;
          transition: background-color 0.2s ease;
          cursor: pointer;
        }

        .login-button:hover {
          background-color: #15157c;
        }

        .login-btn-icon {
          font-size: 16px;
        }
      `}</style>
    </div>
  );
}
